import React from "react";
import { shade, wordWrap } from "polished";
import { Box } from "rebass";
import styled from "styled-components";

const Article = styled(Box)`
  overflow: hidden;
  &:not(:last-child) {
    margin-bottom: 24px;
  }
  * {
    &::selection {
      color: ${(props) => props.theme.colors.grey[2]};
      background-color: ${(props) => props.theme.colors.violet};
    }
  }
  p {
    margin: 0;
    margin-bottom: ${(props) => props.theme.space[4]}px;
    font-size: ${(props) => props.theme.fontSizes[2]}px;
    font-weight: 400;
    line-height: 1.75;
    color: ${(props) => props.theme.colors.text};
    font-kerning: normal;
    font-variant-ligatures: common-ligatures;
    overflow-wrap: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    hyphens: auto;

    &:last-child {
      margin-bottom: 0;
    }
  }
  li strong,
  p strong,
  p b {
    font-weight: ${(props) => props.theme.fontWeights.bold};
  }
  li a,
  p a {
    color: ${(props) => props.theme.colors.violet};
    text-decoration: none;
    box-shadow: inset 0 -1px 0 ${(props) => props.theme.colors.violet};
    transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),
      box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);
    will-change: color, box-shadow;

    &:hover {
      color: #fff;
      box-shadow: inset 0 -1.5em 0 ${(props) => props.theme.colors.violet};
    }
    &:active {
      color: #fff;
      box-shadow: inset 0 -1.5em 0 ${(props) => props.theme.colors.violet && shade(0.75, props.theme.colors.violet)};
    }
  }
  p.block-img img {
    width: 50%;
    margin: 0;
    margin-left: ${(props) => props.theme.space[5]}px;
    margin-right: 0;
    margin-bottom: ${(props) => props.theme.space[5]}px;
    float: right;
    clear: right;

    @media (max-width: 40em) {
      width: 100%;
      float: none;
      clear: both;
      margin-right: 0;
      margin-left: 0;
      margin-bottom: 0;
    }
  }
  ul,
  ol {
    margin-bottom: ${(props) => props.theme.space[5]}px;
    font-size: ${(props) => props.theme.fontSizes[2]}px;
    color: ${(props) => props.theme.colors.text};
  }
  li {
    margin-bottom: 8px;
    line-height: 1.5;

    &:last-child {
      margin-bottom: 0;
    }
  }
  pre {
    width: 100%;
    margin-bottom: ${(props) => props.theme.space[5]}px;
    padding: ${(props) => props.theme.space[5]}px;
    font-size: 14px;
    background-color: ${(props) => props.theme.colors.grey[1]};
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    margin-bottom: ${(props) => props.theme.space[4]}px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.025em;
    color: ${(props) => props.theme.colors.text};
    font-kerning: normal;

    a {
      color: ${(props) => props.theme.colors.violet};
      text-decoration: none;
      box-shadow: inset 0 -1px 0 ${(props) => props.theme.colors.violet};
      transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),
        box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);
      will-change: color, box-shadow;

      &:hover {
        color: #fff;
        box-shadow: inset 0 -1.5em 0 ${(props) => props.theme.colors.violet};
      }
      &:active {
        color: #fff;
        box-shadow: inset 0 -1.5em 0 ${(props) => props.theme.colors.violet && shade(0.75, props.theme.colors.violet)};
      }
    }
  }
  h1 {
    font-size: 30px;
  }
  h2 {
    font-size: 24px;
  }
  h3 {
    font-size: 20px;
  }
  h4 {
    font-size: 16px;
  }
  h5 {
    font-size: 14px;
  }
  h6 {
    text-transform: uppercase;
    letter-spacing: 0.075em;
    font-size: 11px;
  }
  > *[data-oembed-type="video"] {
    position: relative;
    width: 100%;
    margin-bottom: 24px;
    padding-bottom: ${(270 / 480) * 100 + "%"};
    > iframe {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

Article.defaultProps = {
  is: "article",
};

export default Article;



// WEBPACK FOOTER //
// ./src/components/Article.js